import { render, staticRenderFns } from "./ItemDisplayView.vue?vue&type=template&id=3a5d2b59"
import script from "./ItemDisplayView.vue?vue&type=script&lang=js"
export * from "./ItemDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports